import clsx from "clsx";
import type { Moment } from "moment";
import { BooleanSwitchValue } from "consts/general";
import type { BooleanSwitch } from "types";
import { convertToDateTime } from "util/transformers";
import { UiDateTimeFormatter } from "util/formaters";
import type { HighRiskMerchant } from "features/ecommerce/types";
import { OnboardingEntity } from "features/ecommerce/OnboardingEntity";

export class ShareholderIdentity extends OnboardingEntity {
    public readonly name: string;
    public readonly addressLine1: string;
    public readonly addressLine2: string;
    public readonly city: string;
    public readonly postalCode: string;
    public readonly countryOrigin: string | null;
    public readonly dateOfBirth: Moment | null;
    public readonly passportNumber: string;
    public readonly passportExpDate: Moment | null;
    public readonly title: string;
    public readonly email: string | null;
    public readonly phone: string;
    public readonly passportFileKey: string | File | null;
    public readonly utilityBillFileKey: string | File | null;
    public readonly isPep: BooleanSwitch;
    public readonly sharesPercentage: number | null;

    public constructor({
        name = '',
        addressLine1 = '',
        addressLine2 = '',
        city = '',
        postalCode = '',
        countryOrigin = null,
        dateOfBirth = null,
        passportNumber = '',
        passportExpDate = null,
        title = '',
        email = '',
        phone = '',
        passportFileKey = null,
        utilityBillFileKey = null,
        sharesPercentage = null,
        isPep = BooleanSwitchValue.On,
        ...rest
    } = {} as Partial<HighRiskMerchant.Shareholder>) {
        super(rest);

        this.name = clsx(name);
        this.addressLine1 = clsx(addressLine1);
        this.addressLine2 = clsx(addressLine2);
        this.city = clsx(city);
        this.postalCode = clsx(postalCode);
        this.countryOrigin = countryOrigin;
        this.dateOfBirth = convertToDateTime(dateOfBirth, UiDateTimeFormatter.Ui);
        this.passportNumber = clsx(passportNumber);
        this.passportExpDate = convertToDateTime(passportExpDate, UiDateTimeFormatter.Ui);
        this.title = clsx(title);
        this.email = clsx(email);
        this.phone = clsx(phone);
        this.passportFileKey = passportFileKey;
        this.utilityBillFileKey = utilityBillFileKey;
        this.sharesPercentage = sharesPercentage;
        this.isPep = isPep;
    }
}

export default ShareholderIdentity;
